export namespace ProductMedia {
    let initProductMedia = () => {
        let $productMediaItems = $('.js-product-media-item'),
        galleryimagesObject = [],
        clippedimagesObject = [],
        combinedimagesObject = [],
        vignetteimagesObject = [],
        supplementaryimagesObject = [],
        roomimagesObject = [],
        lifestyleimagesObject = [],
        remainingimageObject = [],
        threeSixtyObject = [];

        $productMediaItems.each(function () {
            let $this = $(this),
                id = $this.data('id'),
                type = $this.data('type'),
                index = $this.index() + 1;

             //push all images to the imagesObject
             if (type === 'galleryimage') {
                galleryimagesObject.push(id);
            }else if (type === 'clippedimage') {
                clippedimagesObject.push(id);
            }else if (type === 'combinedimage') {
                combinedimagesObject.push(id);
            }else if (type === 'vignetteimage') {
                vignetteimagesObject.push(id);
            }else if (type === 'supplementaryimage') {
                supplementaryimagesObject.push(id);
            }else if (type === 'roomimage') {
                roomimagesObject.push(id);
            }else if (type === 'lifestyleimage') {
                lifestyleimagesObject.push(id);
            }else if (type === 'remainingimage') {
                remainingimageObject.push(id);
            } else if (type === 'threesixty') {
                threeSixtyObject.push(id);
            }
        });

        function isUnique(value, index, self) {
            return self.indexOf(value) === index;
        }

        let groupedGalleryImageIDs = galleryimagesObject.filter(isUnique).join(','),
        groupedClippedImageIDs = clippedimagesObject.filter(isUnique).join(','),
        groupedCombinedImageIDs = combinedimagesObject.filter(isUnique).join(','),
        groupedVignetteImageIDs = vignetteimagesObject.filter(isUnique).join(','),
        groupedSupplementaryImageIDs = supplementaryimagesObject.filter(isUnique).join(','),
        groupedRoomImageIDs = roomimagesObject.filter(isUnique).join(','),
        groupedLifestyleImageIDs = lifestyleimagesObject.filter(isUnique).join(','),      
        groupedRemainingImageIDs = remainingimageObject.filter(isUnique).join(','),           
        grouped360IDs = threeSixtyObject.filter(isUnique).join(',');
    
    initModal(groupedGalleryImageIDs, groupedClippedImageIDs, groupedCombinedImageIDs, groupedVignetteImageIDs, 
              groupedSupplementaryImageIDs, groupedRoomImageIDs, groupedLifestyleImageIDs, 
              groupedRemainingImageIDs, grouped360IDs);
    };

    let initModal = (galleryImageIDs, clippedImageIDs, combinedImageIDs, vignetteImageIDs, supplementaryImageIDs, roomImageIDs, lifestyleImageIDs, remainingImageIDs,  grouped360IDs) => {
        $('.js-product-media-item').each(function () {
            let $link = $(this).find('.js-product-media-link');
            let currentItemId = $(this).data('id');
            let isSingleImage;

            let imageIds = clippedImageIDs.concat(combinedImageIDs, vignetteImageIDs, supplementaryImageIDs, roomImageIDs, lifestyleImageIDs, remainingImageIDs, galleryImageIDs, grouped360IDs);
            imageIds.length < 1 ? (isSingleImage = '&singleImage=true') : (isSingleImage = '');

            var fullUrlWithParams = `?ids=${galleryImageIDs},clippedids:${clippedImageIDs},combinedids:${combinedImageIDs},vignetteids:${vignetteImageIDs},supplementaryids:${supplementaryImageIDs},lifestyleids:${lifestyleImageIDs},roomids:${roomImageIDs},remainingids:${remainingImageIDs},threesixty:${grouped360IDs}${isSingleImage}`;
            if (currentItemId) {
                fullUrlWithParams = fullUrlWithParams.concat('&selectedItem=' + currentItemId);
            }
            $link.attr('href', '/modal' + fullUrlWithParams);
        });
    };

    export const init = () => {
        initProductMedia();
    };
}
